<template>
  <div>
    <v-tabs
      v-model="tab"
      class="home-tabs"
      align-with-title
    >
      <!--      <v-tabs-slider color="yellow"></v-tabs-slider>-->
      <v-tab href="#home-tab" to="/home-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_request_grey.svg" />
          <p class="home-tabs-title">ثبت درخواست</p>
        </div>
      </v-tab>
      <v-tab href="#profile-tab" to="/report-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_report_grey.svg" />
          <p class="home-tabs-title">گزارش درخواست</p>
        </div>
      </v-tab>
      <v-tab href="#message-tab" to="/message-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_messenger_blue.svg" />
          <p class="home-tabs-title">پیام رسان</p>
        </div>
      </v-tab>
      <v-tab href="#profile-tab" to="/profile-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_account_grey.svg" />
          <p class="home-tabs-title">پروفایل</p>
        </div>
      </v-tab>
      <v-tabs-items>
        <v-card flat>
          <Chats />
        </v-card>
      </v-tabs-items>
    </v-tabs>
  </div>

</template>
<script>
  import Chats from '@/views/messenger/Chats.vue'
  export default {
    data () {
      return {
        tab: null,
      }
    },
    components: {
      Chats
    }
  }
</script>
